/* eslint-disable indent */
import 'antd/dist/antd.css';

import { Button, Message } from '@alifd/next';
import { Image, Modal } from 'antd'; // dialog UI
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import Tab from '@/components/UI/mobile/Tab';

import client from '../../../../../lib/feathers';
import styles from './index.module.scss';
const DeliveryFrontDeskList = () => {
  const deposit = client.service('deposit');
  const postalRegistration = client.service('postalRegistration');
  const [postalArr, setPostalArr] = useState([]);
  const [viewPostalDialog, setViewPostalDialog] = useState(false);
  const [robotDeliveryDialog, setRobotDeliveryDialog] = useState(false);
  const [viewPostal, setViewPostal] = useState({});
  const [tab, setTab] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await client.reAuthenticate();
        const postalRegistrationData = (
          await postalRegistration.find({
            query: {
              household: { $in: res.user.householdNumbers },
              robotDelivery: true,
              $sort: { updatedTime: -1 },
            },
          })
        ).data;
        const depositData = (
          await deposit.find({
            query: {
              household: { $in: res.user.householdNumbers },
              robotDelivery: true,
              type: '收件',
              $sort: { updatedTime: -1 },
            },
          })
        ).data;
        client.io.on('robotStatus', (_, callback) => {
          setIsUpdate((pre) => !pre);
          callback('success');
        });
        setPostalArr([...postalRegistrationData, ...depositData]);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [deposit, postalRegistration, tab, isUpdate]);

  return (
    <>
      <div className={styles.mobileDeposit}>
        <div className={styles.mobileDepositBackground} />
        <div className={styles.main}>
          <Tab options={['郵件包裹', '寄物', '已完成']} onChange={setTab} />
        </div>
        {postalArr
          .filter((postal) => {
            if (tab === 0) {
              return (
                postal?.packageType &&
                postal.status !== '已領取' &&
                postal.status !== '退貨中' &&
                postal.status !== '已退貨'
              );
            } else if (tab === 1) {
              return postal?.type && postal.status !== '已領取';
            } else if (tab === 2) {
              return postal.status === '已領取';
            }
          })
          .map((item, index) => {
            return (
              <div className={styles.main} key={index}>
                <div className={styles.flexStatus}>
                  <div
                    className={
                      (item.status === '已領取' && styles.rectBlue) ||
                      (item.status === '未領取' && styles.rect) ||
                      (item.status === '安排中' && styles.rectGreen) ||
                      (item.status === '派送中' && styles.rectOrigin)
                    }
                  >
                    {item.status}
                  </div>
                  <span className={styles.time}>
                    {moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                  </span>
                </div>
                <div className={styles.DepositMain}>
                  <div className={styles.flexItem}>
                    <div className={styles.bk}>
                      <span className={styles.head}>編號</span>
                      <span className={styles.content}>
                        {item.postalNumberPlate}
                      </span>
                    </div>

                    <div className={styles.bkStatus}>
                      <span className={styles.time}>
                        {moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                      </span>
                      <div
                        className={
                          (item.status === '已領取' && styles.rectBlue) ||
                          (item.status === '未領取' && styles.rect) ||
                          (item.status === '安排中' && styles.rectGreen) ||
                          (item.status === '派送中' && styles.rectOrigin)
                        }
                      >
                        {item.status}
                      </div>
                    </div>
                  </div>

                  <div className={styles.flexItem}>
                    <div className={styles.bk}>
                      <span className={styles.head}>姓名</span>
                      <span className={styles.content}>
                        {item.recipient !== ''
                          ? item.recipient
                          : item.household}
                      </span>
                    </div>
                  </div>
                  {item?.itemName ? (
                    <div className={styles.flexItem}>
                      <div className={styles.bk}>
                        <span className={styles.head}>物品名稱</span>
                        <span className={styles.content}>{item.itemName}</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className={styles.flexItem}>
                        <div className={styles.bk}>
                          <span className={styles.head}>類型</span>
                          <span className={styles.content}>
                            {item.packageType}
                          </span>
                        </div>
                      </div>
                      <div className={styles.flexItem}>
                        <div className={styles.bk}>
                          <span className={styles.head}>擺放位置</span>
                          <span className={styles.content}>
                            {item.placement}
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                  <div className={styles.flexBtn}>
                    <Button
                      type="primary"
                      className={styles.buttonPreview}
                      onClick={() => {
                        setViewPostal({ ...item, tab: tab });
                        setViewPostalDialog(true);
                      }}
                    >
                      查看更多
                    </Button>
                    {tab !== 2 && item.status === '未領取' && (
                      <Button
                        type="primary"
                        className={styles.buttonPreview}
                        onClick={() => {
                          setViewPostal(item);
                          setRobotDeliveryDialog(true);
                        }}
                      >
                        機器人派送
                      </Button>
                    )}
                    {item.status === '派送中' && (
                      <Button
                        type="primary"
                        className={styles.buttonPreview}
                        onClick={() => {
                          try {
                            Swal.fire({
                              title: `確定開啟機器人艙門?`,
                              text: '請確認機器人位置!!',
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#BEBEBE',
                              confirmButtonText: '確定',
                              cancelButtonText: '取消',
                            }).then((result) => {
                              if (result.isConfirmed) {
                                let data = {};
                                if (tab === 0) {
                                  data = {
                                    postalRegistrationId: item._id,
                                    householdNumber: item.household,
                                  };
                                } else {
                                  data = {
                                    depositId: item._id,
                                    householdNumber: item.household,
                                  };
                                }
                                axios.post(
                                  '/ezcon/api/robot/residentOpenGate',
                                  data,
                                  {
                                    headers: {
                                      authorization:
                                        localStorage.getItem('feathers-jwt'),
                                    },
                                  }
                                );
                              }
                            });
                          } catch (error) {
                            console.error(error);
                          }
                        }}
                      >
                        開啟艙門
                      </Button>
                    )}
                  </div>
                </div>
                {postalArr.length - 1 !== index && (
                  <hr className={styles.bcolor} />
                )}
              </div>
            );
          })}
        {!postalArr.filter((postal) => {
          if (tab === 0) {
            return postal?.packageType && postal.status !== '已領取';
          } else if (tab === 1) {
            return postal?.type && postal.status !== '已領取';
          } else if (tab === 2) {
            return postal.status === '已領取';
          }
        }).length > 0 ? (
          <div className={styles.main}>尚無紀錄</div>
        ) : (
          ''
        )}
      </div>
      {/* 查看寄物 */}
      <Modal
        closable={false}
        mask={false}
        className={styles.modal}
        visible={viewPostalDialog}
        okText
        onOk={() => {
          setViewPostalDialog(false);
        }}
        onCancel={() => {
          setViewPostalDialog(false);
        }}
        cancelText="關閉"
      >
        <div className={styles.previewMoreContainer}>
          <div className={styles.previewMoreLeft}>
            <div className={styles.titleText}>編號</div>

            <div className={styles.title}>{viewPostal.postalNumberPlate}</div>
            {tab === 1 && (
              <>
                <div className={styles.titleText}>類別</div>
                <div className={styles.title}>{viewPostal.type}</div>
              </>
            )}
            <div className={styles.titleText}>收件人</div>
            <div className={styles.title}>
              {viewPostal.recipient !== ''
                ? viewPostal.recipient
                : viewPostal.household}
            </div>
            {tab === 1 ? (
              <>
                <div className={styles.titleText}>物品名稱</div>
                <div className={styles.title}>{viewPostal.itemName}</div>
              </>
            ) : (
              <>
                <div className={styles.titleText}>類型</div>
                <div className={styles.title}>{viewPostal.packageType}</div>
                <div className={styles.titleText}>擺放位置</div>
                <div className={styles.title}>{viewPostal.placement}</div>
                {viewPostal.vendor !== '' && (
                  <>
                    <div className={styles.titleText}>廠商</div>
                    <div className={styles.title}>{viewPostal.vendor}</div>
                  </>
                )}
                {viewPostal.logistics !== '' && (
                  <>
                    <div className={styles.titleText}>物流</div>
                    <div className={styles.title}>{viewPostal.logistics}</div>
                  </>
                )}
              </>
            )}

            <div className={styles.titleText}>登記時間</div>
            <div className={styles.title}>
              {moment(viewPostal.packagerRegistrationTime).format(
                'YYYY/MM/DD HH:mm:ss'
              )}
            </div>
            {viewPostal.status === '已領取' && (
              <>
                <div className={styles.titleText}>領取時間</div>
                <div className={styles.title}>
                  {moment(viewPostal.receiveTime).format('YYYY/MM/DD HH:mm:ss')}
                </div>
              </>
            )}
            {viewPostal.remarks !== '' && (
              <>
                <div className={styles.titleText}>備註</div>
                <div className={styles.title}>{viewPostal.remarks}</div>
              </>
            )}
            {viewPostal.residentPhoto !== null && (
              <>
                <div className={styles.titleText}>領取人照片</div>
                <div className={styles.title}>
                  <Image
                    src={viewPostal.residentPhoto}
                    className={styles.viewImage}
                  />
                </div>
              </>
            )}
            {viewPostal.canvas !== null && (
              <>
                <div className={styles.titleText}>領取人簽名</div>
                <div className={styles.title}>
                  <Image src={viewPostal.canvas} className={styles.viewImage} />
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>

      {/* 機器人派送 */}
      <div
        className={styles.showRobotoOpen}
        style={{ display: robotDeliveryDialog ? 'flex' : 'none' }}
      >
        <img
          className={styles.showRobotoImg}
          src="img/robot_home.svg"
          alt="圖片"
        />
        <div style={{ marginTop: 10 }}>
          <Button
            className={styles.robotBtn}
            style={{ marginRight: 10 }}
            onClick={async () => {
              let data = {};
              if (tab === 0) {
                data = {
                  postalRegistrationId: viewPostal._id,
                  householdNumber: viewPostal.household,
                };
              } else {
                data = {
                  depositId: viewPostal._id,
                  householdNumber: viewPostal.household,
                };
              }
              // 20221111 依照展覽需求先改
              const res = await axios.post(
                '/ezcon/api/robot/robotPreparation',
                data,
                {
                  headers: {
                    authorization: localStorage.getItem('feathers-jwt'),
                  },
                }
              );
              if (res.status === 200) {
                setIsUpdate((pre) => !pre);
                Message.success('已安排機器人派送');
                axios
                  .post('/ezcon/api/robot/goGuardHouse', data, {
                    headers: {
                      authorization: localStorage.getItem('feathers-jwt'),
                    },
                  })
                  .then(() => console.log('success'))
                  .catch((error) => console.log(error));

                setRobotDeliveryDialog(false);
              }
              // 原本功能
              // const res = await axios.post('/robot/goGuardHouse', data, {
              //   headers: {
              //     'Content-Type': 'multipart/form-data',
              //     authorization: localStorage.getItem('feathers-jwt'),
              //   },
              //   params: {
              //     type: 'communityData',
              //   },
              // });
              // if (tab === 0) {
              //   await postalRegistration.patch(viewPostal._id, {
              //     ...viewPostal,
              //     arrange: moment().valueOf(),
              //     status: '安排中',
              //   });
              // } else {
              //   await deposit.patch(viewPostal._id, {
              //     ...viewPostal,
              //     arrange: moment().valueOf(),
              //     status: '安排中',
              //   });
              // }
            }}
          >
            是
          </Button>
          <Button
            className={styles.robotBtn}
            onClick={() => {
              setRobotDeliveryDialog(false);
            }}
          >
            否
          </Button>
        </div>
      </div>
    </>
  );
};

export default DeliveryFrontDeskList;
